// extracted by mini-css-extract-plugin
export default {"container":"Cadence_container__p82TB","text":"Cadence_text__34w9f","iconContainer":"Cadence_iconContainer__GnNnJ"};